<template>
  <div class="graph-line-multi-percentual-container">
    <div class="graph-line-multi-percentual">
      <div class="graph-line-multi-percentual-line-container">
        <div
          v-for="(value, index) in renderValues"
          :key="index"
          class="graph-line-multi-percentual-line"
          :style="`background-color: ${value.color}; width: ${String(value.percentual).replace('%', '').replace(',', '.')}%;`"
          :class="{
            'graph-line-multi-percentual-line-hide':
              Number(String(value.percentual).replace('%', '').replace(',', '.')) === 0,
          }"
        />
      </div>
    </div>
    <div v-if="showLegend" class="graph-line-multi-percentual-legend">
      <div v-for="(value, index) in values" :key="index" class="graph-line-multi-percentual-legend-left">
        <v-badge offset-y="-2" dot floating :color="value.color"></v-badge>
        {{ value.title }} ({{ value.total ?? '0' }})
        <span class="ml-3" :style="`color: ${value.color}`">
          {{ value.percentual ?? '0.00' }}{{ String(value.percentual)?.endsWith('%') ? '' : '%' }}
        </span>
      </div>
    </div>
    <div v-if="hint" class="graph-line-multi-percentual-hint">
      {{ hint }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showLegend: {
      type: Boolean,
      default: false,
    },

    hidePercentualInBar: {
      type: Boolean,
      default: false,
    },

    hint: {
      type: String,
    },

    values: {
      type: Array,
      default: () => {
        return [
          {
            title: 'Item 1',
            percentual: 25,
            total: 100,
            color: '#E5D545',
          },
          {
            title: 'Item 2',
            percentual: 75,
            total: 100,
            color: '#442d96',
          },
        ];
      },
    },
  },

  computed: {
    renderValues() {
      return this.values.filter((value) => {
        return Number(String(value.percentual).replace('%', '').replace(',', '.')) > 0;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.graph-line-multi-percentual-container {
  .graph-line-multi-percentual-title {
    font-size: $font-size-xxxs;
    color: $neutral-color-high-medium;
  }
  .graph-line-multi-percentual {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    // .graph-line-multi-percentual-left,
    // .graph-line-multi-percentual-right {
    //   font-size: $font-size-xxxs;
    // }
    // .graph-line-multi-percentual-left {
    //   margin-right: $spacing-03;
    // }
    // .graph-line-multi-percentual-right {
    //   margin-left: $spacing-03;
    // }
    .graph-line-multi-percentual-line-container {
      width: 100%;
      display: flex;
      flex-direction: row;
      height: 14px;
      background-color: $neutral-color-low-dark;
      border-radius: $border-radius-xg;
      overflow: hidden;

      .graph-line-multi-percentual-line {
        height: 14px;
        &:first-of-type {
          border-top-left-radius: $border-radius-xg;
          border-bottom-left-radius: $border-radius-xg;
        }
        &:last-of-type {
          border-top-right-radius: $border-radius-xg;
          border-bottom-right-radius: $border-radius-xg;
        }
        :not(.graph-line-multi-percentual-line-hide) {
        }
      }
    }
  }

  .graph-line-multi-percentual-legend {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-items: center;
    margin-top: $spacing-04;
    color: $brand-color-primary-medium;

    div {
      .v-badge {
        margin: 0 $spacing-03;
      }
    }
    .graph-line-multi-percentual-legend-left {
      margin-right: $spacing-06;
      font-size: $font-size-xxs;
    }
  }

  .graph-line-multi-percentual-hint {
    font-size: $font-size-xxs;
    color: $neutral-color-high-light;
    float: right;
    margin-top: $spacing-04;
  }
}
</style>
